import {GiLaurelCrown} from "react-icons/gi";
import {Badge, Button} from "react-bootstrap";
import {FaTrophy} from "react-icons/fa6";
import './TopicFinished.scss';
import {AiFillTrophy} from "react-icons/ai";
import {useContext} from "react";
import AppContext from "../AppContext";
import {useTranslation} from "react-i18next";

export default function TopicFinished({ perfect, title, message, points, goNext, buttonText }) {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    if(!buttonText)
        buttonText = t('button.continue')

    if(points > 0) {
        if (perfect)
            app.playSfxPerfect()
        else
            app.playSfxSuccess()
    }

    const onNext = () => {
        app.stopSfx()
        goNext()
    }
    return <div id="topic-finished">
        <div className="quiz-finished-inner">
            {points > 0 && <div className="quiz-result-image">
                {perfect ? <>
                        <GiLaurelCrown className="perfect fx" />
                        <GiLaurelCrown className="perfect" />
                    </>
                    : <>
                        <AiFillTrophy className="not-perfect fx" />
                        <AiFillTrophy className="not-perfect" />
                    </>}
            </div>}
            <h1 className="title">{title}</h1>
            <div className="quiz-result-info">
                {message}
                {points > 0 && <><div className="fw-bold">{t('finished.pointsEarned')}</div>
                    <div className="h3 mt-3"><Badge bg="warning"><FaTrophy /> {points}</Badge></div></>}
                <div className="mt-5">
                    <Button variant="primary" size="lg" onClick={goNext}>{buttonText}</Button>
                </div>
            </div>
        </div>
    </div>
}